import React from "react";
import { CheckIcon } from "lucide-react";
import { finalChecklist, images } from "../data/content";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
const needs = ["What to practice.", "When to practice it.", "What to notice.", "And what to do next."];
export function FinalCtaSection() {
  return <section className="w-full bg-ink px-5 py-16 text-white sm:py-20" data-id="element-107" data-mp="3vs46a91z3pf9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-108" data-mp="2y5nbbagppnwo">
        <h2 className="font-serif text-[30px] font-black leading-tight sm:text-5xl" data-id="element-109" data-mp="2y312z8lzz4de">
          Ready to stop guessing and <em className="text-gold" data-id="element-110" data-mp="3831maujv9khl">start training with a system?</em>
        </h2>
        <p className="mt-5 text-lg text-white/75" data-id="element-111" data-mp="38173bls5o2g5">You don’t need another hundred pages of random advice. You need to know:</p>
        <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-112" data-mp="2femeot32e4ga">
          {needs.map(n => <li key={n} className="flex items-center gap-3 font-serif text-xl font-bold" data-id="element-113" data-mp="2kcxlsw1z60ut">
              <span className="h-2 w-2 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-114" data-mp="2dbqmx7aqd7wa" />
              {n}
            </li>)}
        </ul>
        <p className="mt-6 text-lg text-white/75" data-id="element-115" data-mp="28dfd2wkfqxe2">That’s exactly what I built inside The Sexual Control Protocol™. Start your 28-day journey today.</p>

        <img src={images.mainMockup} alt="The Sexual Control Protocol complete package" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-116" data-mp="1yndlhusviwue" />

        <div className="mt-6 rounded-3xl bg-white p-6 text-ink sm:p-8" data-id="element-117" data-mp="1un3j0s4aioka">
          <p className="text-sm font-bold uppercase tracking-wider text-ink/60" data-id="element-118" data-mp="1pm5zab3mtmgo">One-time payment</p>
          <p className="font-serif text-7xl font-black leading-none" data-id="element-119" data-mp="1kmjffitat7yw">
            <span className="align-top text-3xl" data-id="element-120" data-mp="1fohu0r8egwk9">$</span>27
          </p>
          <ul className="mx-auto mt-6 grid max-w-md grid-cols-1 gap-2 text-left sm:grid-cols-2" data-id="element-121" data-mp="1fqchodb232s1">
            {finalChecklist.map(item => <li key={item} className="flex items-center gap-2 text-[15px] font-medium" data-id="element-122" data-mp="3a1r4al8rsm3k">
                <CheckIcon className="h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="18clbu2hq9y70" />
                {item}
              </li>)}
          </ul>
          <div className="mt-7" data-id="element-124" data-mp="1d5mwkr4m8ryi">
            <CtaButton label="Yes — I want the Protocol™" sub="One-time payment of $27 · Immediate access · Lifetime access · 7-Day Guarantee" data-id="element-125" data-mp="yfp07nwj8vy8" />
          </div>
        </div>

        <div className="mt-10" data-id="element-126" data-mp="1r3l4pescfs5k">
          <Countdown dark note="Get the introductory $27 price while it’s available." data-id="element-127" data-mp="1r4mivs4nouri" />
        </div>

        <div className="mt-8" data-id="element-128" data-mp="1w1mo60tolthk">
          <CtaButton label="Start the 28-day protocol" dark data-id="element-129" data-mp="1w1wejpin22ns" />
        </div>
      </div>
    </section>;
}